import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import store from "../../../store";
import Globals from '../../../globals'

const selectorStyle = {
    minWidth: '200px',
}

const getAvailableStores = () => {
    const state = store.getState()
    const storeList = Globals.selector.selectStoreList(state)

    return storeList.map(store => {
        return {
            value: store.id,
            label: `${store.displayName}`
        }
    })
}

const getCustomerStore = (options, customer) => {
    return options.filter(store => {
        return store.value === customer.storeId
    }).shift()
}

const StoreSelector = ({
      reassignStore,
      customer
}) => {
    const options = getAvailableStores()

    const changeHandler = (data) => {
        reassignStore(data.value, customer.id)
    }

    return (
        <div className="qa-clinics-selector" style={selectorStyle}>
            <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={getCustomerStore(options, customer)}
                isSearchable={true}
                options={options}
                onChange={changeHandler}
            />
        </div>
    )
}

StoreSelector.propTypes = {
    customer: PropTypes.object.isRequired,
    reassignStore: PropTypes.func.isRequired,
}

export default StoreSelector



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/StoreSelector.js